// @flow
import React, { useState } from 'react'
import FileCard from './FileCard'
import styles from './styles.css'
import type { DigitalFile as DigitalFileType } from 'lib/digital_file/model'

type Props = {
  archived: Array<DigitalFileType>,
  onRestore: (id: number) => mixed,
  onView: (key: ?string, contentType: ?string, name: ?string) => mixed,
  onDownload: (key: ?string) => mixed,
}

const ArchivedBlock = ({ archived, onRestore, onView, onDownload }: Props) => {
  const [open, setOpen] = useState(false)
  const count = archived.length

  return (
    <div className={styles.archivedBlock}>
      <div
        className={styles.archivedHeader}
        onClick={() => setOpen((v) => !v)}
        role="button"
        tabIndex={0}
      >
        <span className={styles.archivedLabel}>
          <span className={styles.chev}>{open ? '▾' : '▸'}</span>
          Archived
        </span>
        <span className={styles.archivedCount}>{count}</span>
      </div>
      {open ? (
        <div className={styles.archivedList}>
          {count === 0 ? (
            <div className={styles.archivedEmpty}>
              No archived documents in this folder.
            </div>
          ) : (
            archived.map((f) => (
              <FileCard
                key={f.id}
                file={f}
                archived
                onRestore={onRestore}
                onView={onView}
                onDownload={onDownload}
              />
            ))
          )}
        </div>
      ) : null}
    </div>
  )
}

export default ArchivedBlock
